import SsoService from '@/services/common/SsoService';

const Sso = new SsoService();

export const getAllSso = async({ commit }: {commit: Function}) => {
    commit('isFetching', true);
    const sso = await Sso.getAllSso();
    commit('allSso', sso);
    commit('isFetching', false);
}
export const updateSsoSettings = async ({ commit }: { commit: Function }, payload: { domain: string, settings: any, customerId?: string }) => {
    commit('isFetching', true);
    await Sso.updateSsoSettings(payload.domain, payload.settings, payload.customerId);
    commit('isFetching', false);
};